import { RateData } from "./RateData";
import { Pair } from "./Pair";
import { SellOffer } from "../entity/SellOffer";

export class ChartData {
   termFrom: Date|null = null;
   termTo: Date|null = null;
   ratesFrom: Date|null = null;
   ratesTo: Date|null = null;
   name: string;
   contractId: number;
   isKilowantContract: boolean;
   contractPrice: number;
   contractPendingAcceptanceBySeller: boolean;
   sellerLeftSeconds: number;
   contractPendingAcceptanceByBuyer: boolean;

   earliestOfferPriceValue: number;
   earliestOfferPriceOfferId: number;
   earliestOfferPricePeriod: Pair;

   selectedOfferPriceValue: number;
   selectedOfferPriceOfferId: number;
   selectedOfferPricePeriod: Pair;

   buyOfferId: number;
   buyOfferPriceValue: number;
   buyOfferPricePeriod: Pair;
   utilityAveragePrice: number;
   communityAveragePrice: number;
   ratesPeriodicity: string;
   rates: RateData[];
   diffCommunity: number;
   diffUtility: number;
   diffContract: number;
   isCurrent: boolean;
   isFuture: boolean;

   showCounterButton: boolean = false;
   showSubmitButton: boolean = false;
   showUpdateButton: boolean = false;

   activeRates: RateData[];

   isPast(): boolean {
     return !this.isCurrent && !this.isFuture;
   }

   isSuggested(): boolean {
     return (this.buyOfferId==0);
   }

   hasSellOffer(sellOffer: SellOffer): boolean {
     if ((this.termFrom==null || this.termFrom<=sellOffer.termFrom) && (this.termTo==null || this.termTo>=this.getTermTo(sellOffer.termFrom, sellOffer.termPeriod))) {
        return true;
     }
     return false;
   }

   hasMissingRates(): boolean {
     if (this.rates.length==0) {
        return true;
     }
     for (let i=0; i<this.rates.length; i++) {
        if (this.rates[i].series==null || this.rates[i].series.length==0) {
           return true;
        }
     }
     return false;
   }

   countRates(): number {
     if (this.rates.length==0) {
        return 0;
     }
     var names: string[] = [];
     for (let i=0; i<this.rates.length; i++) {
        if (this.rates[i].series!=null || this.rates[i].series.length>0) {
           for (let p=0; p<this.rates[i].series.length; p++) {
              if (this.rates[i].series[p]!=null && !names.includes(this.rates[i].series[p].name)) {
                 names.push(this.rates[i].series[p].name);
              }
           }
           return names.length;
        }
     }
     return 0;
   }

   getTermTo(termFrom: Date, termPeriod: number): Date {
      var d = new Date(termFrom);
      return new Date(d.setMonth(d.getMonth() + termPeriod));
   }

}